module.exports = __webpack_public_path__ + "img/Map-Folder-Internal.fcb36243.png";